<template>
  <div class="SalarPlanDialog">
    <el-dialog title="提示" :visible.sync="dialogVisible" width="30%">
      <span>这是一段信息</span>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="dialogVisible = false">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
export default {
  props: ['flog', 'detilObj'],
  data () {
    return {
      dialogVisible: this.flog,
      obj: this.detilObj
    }
  },
  created () {
    console.log(this.flog, this.detilObj);
  }
}
</script>

<style></style>


// WEBPACK FOOTER //
// src/manager/components/SalarPlanDialog.vue